// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardError_cls1__m5Iqs","cls2":"VeloCardError_cls2__1bnmu VeloCardError_cls1__m5Iqs"};